import React from 'react'

export default function Categories() {
  return (
    <div style={{fontSize:"25px",textAlign:"center",paddingTop:"20px"}}>Coming soon...</div>
  )
}
